import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import addDays from '../../utils/common/addDays';

// Payroll should always be completed based on Sydney time
const SYDNEY_TIMEZONE = 'Australia/Sydney';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.tz.setDefault(SYDNEY_TIMEZONE);

// A sample start date for payroll
const SAMPLE_PAYROLL_START_DATETIME = dayjs('2023-06-26 00:00:00');

// Each payroll run is 2 weeks long, and one of the start date is SAMPLE_PAYROLL_START_DATE.
// This function returns the start date of the previous payroll cycle based on the currDatetime
// passed in.
// If currDatetime is not passed in, then it defaults to the current time.
export const getPayrollStartDatetime = (currDatetime: Dayjs = dayjs()): Dayjs => {
  const elapsedCyclesSinceSampleDatetime = Math.floor(
    currDatetime.diff(SAMPLE_PAYROLL_START_DATETIME, 'week') / 2,
  );

  // addDays is used instead of .add to handle daylight savings
  // We subtract 1 from elapsedCyclesSinceSampleDatetime because we seek the previous cycle,
  // not the current one
  const currentPayrollStartDatetime = addDays(
    SAMPLE_PAYROLL_START_DATETIME, (elapsedCyclesSinceSampleDatetime - 1) * 14,
  );

  return currentPayrollStartDatetime;
};

export const getPayrollEndDatetime = (currDatetime: Dayjs = dayjs()): Dayjs => {
  const payrollStartDatetime = getPayrollStartDatetime(currDatetime);

  return addDays(payrollStartDatetime, 13).endOf('day');
};
